export function setIsLoadingInsuranceRight(state, payload) {
  state.isLoadingInvoices = payload;
}

export function setInsuranceRight(state, payload) {
  state.insuranceRight = payload;
}

export function setIsSavingInsuranceRight(state, payload) {
  state.isSavingInsuranceRight = payload;
}
